// The 9-series is reserved for startup checklists.
export const isStartupChecklistTemplate = (templateId?: number) => String(templateId ?? "").startsWith("9");
